import { abrirEmAppNativo, abrirExterno, enderecosDeWhatsapp } from 'services/navegacaoExterna';
import { ehNativo } from 'services/plataforma';

/**
 * Um link que sai do site — WhatsApp, e-mail, qualquer endereço de terceiro.
 *
 * Continua sendo um `<a href>` de verdade nas duas plataformas: é um link, e trocá-lo por um botão
 * custaria o menu de contexto, o "copiar endereço", o comportamento do leitor de tela e o próprio
 * href visível na barra de status do navegador. O que muda no app é só o que acontece no clique.
 *
 * <h2>Por que interceptar</h2>
 * `target="_blank"` numa WebView ou é ignorado ou carrega o destino POR CIMA do bundle — e sem barra
 * de endereço a pessoa fica presa fora do app. No caso do WhatsApp há um segundo problema, este de
 * produto: `wa.me` aberto num navegador embutido mostra uma landing page pedindo para abrir o
 * WhatsApp, em vez de abrir a conversa. O esquema `whatsapp://` vai direto.
 *
 * <h2>Onde isso já valia</h2>
 * Os lugares que mostram os canais de atendimento passam por aqui: o rodapé (que percorre
 * `config/linksInstitucionais`), o FAQ e o Quem Somos — e, até deixar de listá-los, a gaveta "Ajuda"
 * do menu mobile. Antes eram quatro `<a target="_blank">` iguais, e consertar o app significaria
 * lembrar dos quatro.
 */
export default function LinkExterno({ href, children, onClick, ...resto }) {
	const aoClicar = (evento) => {
		// O onClick de quem chama roda SEMPRE e primeiro, nas duas plataformas: no menu mobile ele é
		// o `closeMenu`, e o painel precisa fechar mesmo quando o clique é interceptado abaixo. Ele
		// vem desestruturado das props justamente para não ser sobrescrito pelo spread.
		onClick?.(evento);

		if (!ehNativo()) return; // na web o próprio href resolve

		evento.preventDefault();

		// O wa.me tem tratamento próprio porque existe um app melhor que a página dele.
		if (/wa\.me\//.test(href)) {
			abrirEmAppNativo(enderecosDeWhatsapp(href));
			return;
		}

		abrirExterno(href);
	};

	return (
		<a href={href} target="_blank" rel="noopener noreferrer" onClick={aoClicar} {...resto}>
			{children}
		</a>
	);
}
